var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.xeroCheck)?_c('div',[(!_vm.xeroAuthenticated)?[_c('authorise-xero')]:_vm._e(),(_vm.xeroAuthenticated)?[_c('v-container',{attrs:{"fluid":""}},[_c('xero-list')],1)]:_vm._e()],2):_c('v-main',{attrs:{"app":""}},[_c('v-container',{attrs:{"fluid":""}},[_c('standard-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }